import axios from 'axios';
import { Loading, Message } from 'element-ui'
const service1 = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    // easy-mock服务挂了，暂时不使用了
    // baseURL: 'http://192.168.1.112:8600',
    timeout: 5000
});

let loadinginstace
service1.interceptors.request.use(
    config => {
        config.headers={
            'content-type':'multipart/form-data; charset=utf-8'
        }
        loadinginstace = Loading.service({ fullscreen: true })
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

service1.interceptors.response.use(
    response => {
        loadinginstace.close();
        if (response.status === 200) {
            return response.data;
        } else {
            Promise.reject();
        }
    },
    error => {
        loadinginstace.close();
        console.log(error);
        return Promise.reject();
    }
);

export default service1;



// WEBPACK FOOTER //
// ./src/utils/request1.js